module.exports = __webpack_public_path__ + "img/visualize_the_web_2.94410977.png";